import { MutationHookOptions } from '@apollo/client'
import {
  DeleteTrainingClassesDocument,
  DeleteTrainingClassesMutation,
  DeleteTrainingClassesMutationVariables,
  GroupsTableDocument,
  TrainingClassDetailIndexPageDocument,
  TrainingClassesDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  DeleteTrainingClassesMutation,
  DeleteTrainingClassesMutationVariables
>
export const useDeleteTrainingClasses = (options?: Options) => {
  const [deleteTrainingClass, { loading, error }] = useMutation(DeleteTrainingClassesDocument, {
    ...options,
    extractorFn: (data) => data.trainingsMutations.deleteTrainingsTrainingClass,
  })

  return {
    loading,
    error,
    delete(variables: DeleteTrainingClassesMutationVariables) {
      return deleteTrainingClass({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [
          TrainingClassesDocument,
          GroupsTableDocument,
          TrainingClassDetailIndexPageDocument,
        ],
      })
    },
  }
}
